module.exports = __webpack_public_path__ + "static/media/venue.57ca399c.png";